// extracted by mini-css-extract-plugin
module.exports = {"Header":"Header_Header__2C_Ub","logo":"Header_logo__3_SJs","Title":"Header_Title__3TqbF"};